import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { useSettingFaireDirectPDPSignup } from "@faire/retailer-visitor-shared/settings/useSettingFaireDirectPDPSignup";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Lock } from "@faire/web--source/slate/icons/foundation/Lock";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { Tooltip } from "@faire/web--source/slate/Tooltip";
import { TooltipTypography, Typography, TypographyStyles } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var LoggedOutPrice = function(param) {
    var retailPrice = param.retailPrice, _param_showWSP = param.showWSP, showWSP = _param_showWSP === void 0 ? true : _param_showWSP;
    var _useRetailerStore = useRetailerStore([
        "isUK"
    ]), isUKRetailer = _useRetailerStore.isUK;
    var settingFaireDirectPDPSignup = useSettingFaireDirectPDPSignup();
    var wholesalePrice = settingFaireDirectPDPSignup ? /*#__PURE__*/ _jsx(LockedWholesalePriceV2, {}) : /*#__PURE__*/ _jsxs(LockedPriceRow, {
        gap: 4,
        justify: "center",
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                color: Decorative.shade.orange,
                children: /*#__PURE__*/ _jsx(WholesalePriceText, {})
            }),
            /*#__PURE__*/ _jsx(Lock, {
                lockType: "foundation",
                color: Decorative.shade.orange,
                "data-test-id": "logged-out-price-lock"
            })
        ]
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                gap: "2x",
                "data-test-id": "product-price",
                children: [
                    showWSP ? wholesalePrice : null,
                    /*#__PURE__*/ _jsx(ProductPrice, {
                        children: isUKRetailer ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "7R5b/a",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "RRP "
                                },
                                {
                                    type: 1,
                                    value: "retailAmountMoney"
                                }
                            ],
                            values: {
                                retailAmountMoney: retailPrice
                            }
                        }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "K1SkyV",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "MSRP "
                                },
                                {
                                    type: 1,
                                    value: "retailAmountMoney"
                                }
                            ],
                            values: {
                                retailAmountMoney: retailPrice
                            }
                        })
                    })
                ]
            })
        ]
    });
};
var LockedWholesalePriceV2 = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var isMobile = useViewport().isMobile;
    return /*#__PURE__*/ _jsxs(Row, {
        gap: 4,
        justify: "center",
        align: "center",
        children: [
            isMobile ? /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansRegular",
                children: /*#__PURE__*/ _jsx(WholesalePriceText, {})
            }) : /*#__PURE__*/ _jsx(Tooltip, {
                width: 226,
                position: "top",
                contents: [
                    {
                        body: strictLocalize({
                            id: "P36ySB",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Sign up for Faire to unlock wholesale pricing"
                                }
                            ]
                        })
                    }
                ],
                targetNode: /*#__PURE__*/ _jsx(TooltipTypography, {
                    children: /*#__PURE__*/ _jsx(WholesalePriceText, {})
                })
            }),
            /*#__PURE__*/ _jsx(Lock, {
                lockType: "foundation",
                "data-test-id": "logged-out-price-lock"
            })
        ]
    });
};
var WholesalePriceText = function() {
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "RF3SVf",
        defaultMessage: [
            {
                type: 0,
                value: "WSP"
            }
        ]
    });
};
var ProductPrice = styled.h1.withConfig({
    componentId: "sc-18126a2d-0"
})([
    "",
    ";"
], function(props) {
    return TypographyStyles({
        variant: "paragraphSansRegular",
        color: Core.text.default,
        theme: props.theme
    });
});
var LockedPriceRow = styled(Row).withConfig({
    componentId: "sc-18126a2d-1"
})([
    "background-color:",
    ";padding:",
    ";"
], Decorative.tint.orange, getSpacing(4, "2x"));
